import axios, { AxiosRequestConfig } from "axios";
import { trace as startTrace } from "firebase/performance";
import { perf } from "../../utils/firebase";

interface Data {
  meta: { GTI: string };
  start: number;
  size: number;
  segments: Segment[];
  category_keys: string[];
  status: string;
  channels: string[];
  platform: string;
  page_type: string;
  query?: string;
}

interface Segment {
  label: string;
  value: {
    $in?: string[];
    $eq?: string;
  };
}

export const getProducts = async (
  gti: string,
  query?: string,
  isNewArrival?: boolean,
  query_category_keys: string[] = ["c10003"],
  concerns?: string[],
  type?: string
) => {
  const url = `${process.env.REACT_APP_GCP_BASE_URL}/glamlab/api/hair/v1/products`;
  const page_type = isNewArrival ? "new_arrival" : "category";

  let data: Data = {
    meta: { GTI: gti ?? "" },
    start: 0,
    size: 12,
    category_keys: query_category_keys,
    status: "live",
    channels: ["online-sale", "online"],
    platform: "WEB",
    page_type: page_type,
    segments: [],
  };

  if (!isNewArrival) {
    data.query = query;
  }

  if (concerns && concerns.length > 0) {
    data.segments.push({
      label: "CONCERNS",
      value: {
        $in: concerns,
      },
    });
  }

  if (type) {
    data.segments.push({
      label: "TYPE",
      value: {
        $eq: type,
      },
    });
  }

  const axiosConfig: AxiosRequestConfig = {
    url: url,
    method: "POST",
    params: null,
    data: data,
    headers: {
      "x-api-key": process.env.REACT_APP_GCP_API_KEY,
      "Content-Type": "application/json",
    },
  };

  const trace = startTrace(perf, `Api call: ${url}`);
  trace.start();

  try {
    const response = await axios(axiosConfig);
    return response;
  } catch (error) {
    throw error;
  } finally {
    trace.stop();
  }
};
